var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalBasic01 = function SvgCalBasic01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80.13,
    y1: -28.5,
    x2: 226.17,
    y2: 134.65,
    gradientTransform: "translate(0 201) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.51,
    y1: 15.03,
    x2: 177.55,
    y2: 178.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7.08,
    y1: 36.89,
    x2: 153.12,
    y2: 200.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 33.02,
    y1: 13.67,
    x2: 179.06,
    y2: 176.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 58.82,
    y1: -9.42,
    x2: 204.86,
    y2: 153.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 28.39,
    y1: 17.82,
    x2: 174.43,
    y2: 180.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 54.33,
    y1: -5.4,
    x2: 200.37,
    y2: 157.75,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.39,171.75h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM136.68,145.59h19.59v19.59h-19.59v-19.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.72,18.97h-5.48v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1,0-12.88,5.78-12.88,12.88v6.04H62.1v-6.04C62.1,5.83,56.32.05,49.22.05h-3.95c-7.1,0-12.88,5.78-12.88,12.88v6.04h-5.11c-15.04,0-27.28,12.23-27.28,27.28v126.42c0,15.04,12.24,27.28,27.28,27.28h145.44c15.04,0,27.28-12.24,27.28-27.28V46.25c0-15.04-12.24-27.28-27.28-27.28ZM144.09,12.93c0-3.48,2.83-6.3,6.3-6.3h3.96c3.48,0,6.3,2.83,6.3,6.3v20.56c0,3.48-2.83,6.3-6.3,6.3h-3.96c-3.48,0-6.3-2.83-6.3-6.3V12.93ZM38.95,12.93c0-3.48,2.83-6.3,6.3-6.3h3.96c3.48,0,6.3,2.83,6.3,6.3v20.56c0,3.48-2.83,6.3-6.3,6.3h-3.96c-3.48,0-6.3-2.83-6.3-6.3V12.93ZM6.57,46.25c0-11.42,9.29-20.71,20.71-20.71h5.11v7.94c0,7.1,5.78,12.88,12.88,12.88h3.96c7.1,0,12.88-5.78,12.88-12.88v-7.94h75.43v7.94c0,7.1,5.78,12.88,12.88,12.88h3.96c7.1,0,12.88-5.78,12.88-12.88v-7.94h5.48c11.42,0,20.71,9.29,20.71,20.71v26.89H6.57v-26.89ZM193.43,172.67c0,11.42-9.29,20.71-20.71,20.71H27.27c-11.42,0-20.71-9.29-20.71-20.71v-92.97h186.86v92.96h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.19,128.87h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM43.48,102.71h19.59v19.59h-19.59v-19.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.92,128.87h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM90.2,102.71h19.59v19.59h-19.59v-19.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.39,128.87h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM136.68,102.71h19.59v19.59h-19.59v-19.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.19,171.75h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM43.48,145.59h19.59v19.59h-19.59v-19.59Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.92,171.75h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29ZM90.2,145.59h19.59v19.59h-19.59v-19.59Z"
  })));
};
export default SvgCalBasic01;